// Remembers, for this browser tab, that the user tried to sign in with an SSO account that isn't
// linked yet, so they're taken to SSO onboarding once they've logged in with their password
// (even when SSO isn't required).
const key = "ssoLinkRequested";

export function requestSsoLink() {
    try {
        sessionStorage.setItem(key, "true");
    }
    catch {
        // Storage unavailable - the user can still link from the onboarding page.
    }
}

export function isSsoLinkRequested() {
    try {
        return sessionStorage.getItem(key) === "true";
    }
    catch {
        return false;
    }
}

export function clearSsoLinkRequest() {
    try {
        sessionStorage.removeItem(key);
    }
    catch {
        // Nothing to clear.
    }
}
